import {MeshPoint} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshPoint';
import {MeshSize} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshSize';

export class MeshBounds
{
    private constructor(public x:number,
                        public y:number,
                        public width:number,
                        public height:number)
    {
    }

    public getTopLeft():MeshPoint
    {
        return MeshPoint.from(this.x, this.y);
    }

    public getSize():MeshSize
    {
        return MeshSize.from(this.width, this.height);
    }

    public static from(x:number, y:number, width:number, height:number):MeshBounds
    {
        return new MeshBounds(x, y, width, height);
    }

    public clone():MeshBounds
    {
        return new MeshBounds(this.x, this.y, this.width, this.height);
    }
}
